import { DollarOutlined, UserOutlined } from '@ant-design/icons'
import { Spin } from 'antd'
import { StakingTokenStatisticalType } from 'Modules'
import { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { AppAdmin } from 'api/app-admin'
import { logError } from 'utils/logger'

const Overview = () => {
  const location = useParams()

  const poolId = location.id

  const [data, setData] = useState<StakingTokenStatisticalType | null>(null)
  const [loadingData, setLoadingData] = useState(false)

  const getData = useCallback(async () => {
    setLoadingData(true)
    try {
      if (!poolId) return
      const res = await AppAdmin.getStatisticalPool(poolId)
      if (res?.data.success) {
        setData(res?.data.data)
      }
    } catch (err) {
      logError(err)
    } finally {
      setLoadingData(false)
    }
  }, [poolId])

  useEffect(() => {
    getData()
  }, [getData, poolId])

  return (
    <div className="dashboard-container">
      <div className="wrap-dashboard">
        <div className="wrap-box">
          <div className="title">Staked Overview</div>
          <div className="wrap-columns">
            <div className="columns">
              <div className="colum w-3 w-sm-6">
                <div className="guide-box">
                  <div className="box-content">
                    <div className="left-s">
                      <div className="txt">Total Users</div>
                      <div className="number">
                        {loadingData ? (
                          <Spin />
                        ) : (
                          new Intl.NumberFormat('en-US').format(data?.totalUsers || 0)
                        )}
                      </div>
                    </div>
                    <div className="right-s">
                      <div className="icon">
                        <UserOutlined />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="colum w-3">
                <div className="guide-box">
                  <div className="box-content">
                    <div className="left-s">
                      <div className="txt">Total Staked (MEY)</div>
                      <div className="number">
                        {loadingData ? (
                          <Spin />
                        ) : (
                          new Intl.NumberFormat('en-US').format(data?.totalTokenStaked || 0)
                        )}
                      </div>
                    </div>
                    <div className="right-s">
                      <div className="icon">
                        <DollarOutlined />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="colum w-3">
                <div className="guide-box">
                  <div className="box-content">
                    <div className="left-s">
                      <div className="txt">Total Reward Claimed (MEY)</div>
                      <div className="number">
                        {loadingData ? (
                          <Spin />
                        ) : (
                          new Intl.NumberFormat('en-US').format(
                            data?.totalRewardsClaimedAmount || 0
                          )
                        )}
                      </div>
                    </div>
                    <div className="right-s">
                      <div className="icon">
                        <DollarOutlined />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="colum w-3">
                <div className="guide-box">
                  <div className="box-content">
                    <div className="left-s">
                      <div className="txt">Estimate Reward Available Claim (MEY)</div>
                      <div className="number">
                        {loadingData ? (
                          <Spin />
                        ) : (
                          new Intl.NumberFormat('en-US').format(data?.estimateRewardsAvailable || 0)
                        )}
                      </div>
                    </div>
                    <div className="right-s">
                      <div className="icon">
                        <DollarOutlined />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="colum w-3">
                <div className="guide-box">
                  <div className="box-content">
                    <div className="left-s">
                      <div className="txt">Estimate Reward Distributed (MEY)</div>
                      <div className="number">
                        {loadingData ? (
                          <Spin />
                        ) : (
                          new Intl.NumberFormat('en-US').format(
                            data?.estimateRewardsDistributed || 0
                          )
                        )}
                      </div>
                    </div>
                    <div className="right-s">
                      <div className="icon">
                        <DollarOutlined />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Overview
